import React from "react";
import styles from "./input-with-header.module.scss";
import drop_down_arrow from "../../assets/drop_down_arrow_down.svg";
import up_arrow from "../../assets/up-arrow.svg";

type InputWithHeaderProps = {
  header: string;
  placeholder: string;
  type: "dropdown" | "string" | "number" | "amount";
  onPressDropDown?: () => void;
  value: string | number;
  handleChange?: (formKey: string, value: string) => void;
  formKey?: string;
  error?: string;
  editable?: boolean;
  currencySymbol?: string;
};

function formatAmountNaira(number: number) {
  if (!isFinite(number)) return "";

  return `₦${number.toLocaleString("en-NG")}`;
}

const extractDigits = (value: string) => value.replace(/\D/g, "");

const InputWithHeader = ({
  header,
  placeholder,
  type,
  value,
  formKey,
  editable,
  error,
  currencySymbol,
  handleChange,
  onPressDropDown,
}: InputWithHeaderProps) => {
  const isClickable = type === "dropdown";
  const formattedValue =
    type === "amount"
      ? Number(value) > 0
        ? formatAmountNaira(Number(value))
        : ""
      : currencySymbol && Number(value) > 0 // 👈 non-NGN foreign currency
      ? `${currencySymbol}${Number(value).toLocaleString()}`
      : value;

  const decrement = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!handleChange || !formKey) return;

    const current = Number(value) || 0;
    if (current <= 0) return;

    handleChange(formKey, String(current - 1));
  };

  const increment = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!handleChange || !formKey) return;

    const current = Number(value) || 0;
    handleChange(formKey, String(current + 1));
  };

  return (
    <div className={styles.cont}>
      <span className={styles["header-txt"]}>{header}</span>

      <div
        className={styles["input-cont"]}
        role="button"
        onClick={isClickable ? onPressDropDown : undefined}
        style={{ cursor: "pointer" }}
      >
        <input
          className={styles.input}
          readOnly={isClickable || editable === false}
          style={{
            cursor: isClickable ? "pointer" : "default",
          }}
          placeholder={placeholder}
          value={formattedValue}
          onChange={(e) => {
            if (!handleChange || !formKey) return;

            if (type === "amount") {
              const digits = extractDigits(e.target.value);
              handleChange(formKey, digits);
            } else {
              handleChange(formKey, e.target.value);
            }
          }}
          type={type === "number" ? "number" : undefined}
        />

        {isClickable ? (
          <img
            src={drop_down_arrow}
            alt=""
            className={styles["drop-down-arrow"]}
          />
        ) : null}

        {type === "number" ? (
          <div className={styles.control}>
            <div className={styles["control-inner"]} onClick={increment}>
              <img src={up_arrow} alt="" />
            </div>
            <div className={styles["control-inner"]} onClick={decrement}>
              <img src={drop_down_arrow} alt="" />
            </div>
          </div>
        ) : null}
      </div>

      {error ? <span className={styles["error-txt"]}>{error}</span> : null}
    </div>
  );
};

export default InputWithHeader;
